import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import {ExampleStampComponent} from '@entities/example-stamp/example-stamp/example-stamp.component';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {UserRouteAccessService} from '@app/core';
import {ExampleStampPopupComponent} from '@entities/example-stamp/example-stamp-dialog/example-stamp-dialog.component';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {of} from 'rxjs';
import {ExampleStampService} from '@entities/example-stamp/example-stamp.service';
import {IStamp, Stamp} from '@entities/example-stamp/example-stamp.model';
import {ExampleStampDeletePopupComponent} from '@entities/example-stamp/example-stamp-delete-dialog/example-stamp-delete-dialog.component';

@Injectable({providedIn: 'root'})
export class StampDetailResolve implements Resolve<IStamp> {
  constructor(private service: ExampleStampService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['code'] ? route.params['code'] : null;

    if (id) {
      return this.service
        .find(id)
        .pipe(map((response: HttpResponse<IStamp>) => response.body));
    }
    return of(new Stamp());
  }
}

export const ExampleStampRoute: Routes = [
  {
    path: 'danh-sach-mau-tem',
    component: ExampleStampComponent,
    resolve: {
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      pageTitle: 'entities.example-stamp.example-stamp.Danh sách Mẫu Tem_title',
    },
    canActivate: [UserRouteAccessService],
  },
  {
    path: 'tao-mau-tem',
    component: ExampleStampPopupComponent,
    data: {
      pageTitle:
        'entities.example-stamp.example-stamp-dialog.Tạo mẫu tem_dialog_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'sua-mau-tem/:code',
    component: ExampleStampPopupComponent,
    data: {
      pageTitle:
        'entities.example-stamp.example-stamp-dialog.Sửa mẫu tem_dialog_title',
    },
    canActivate: [UserRouteAccessService],
    resolve: {
      data: StampDetailResolve,
    },
    outlet: 'popup',
  },
  {
    path: 'xoa-mau-tem/:code',
    component: ExampleStampDeletePopupComponent,
    data: {
      pageTitle:
        'entities.example-stamp.example-stamp-delete.Xóa mẫu tem_dialog_title',
    },
    canActivate: [UserRouteAccessService],
    resolve: {
      data: StampDetailResolve,
    },
    outlet: 'popup',
  },
];
